import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface UserManagementPlaceholderPageProps {
  title: string;
  description: string;
  ctaLabel?: string;
  ctaTo?: string;
}

export function UserManagementPlaceholderPage({
  title,
  description,
  ctaLabel = 'Back to Users',
  ctaTo = '/users',
}: UserManagementPlaceholderPageProps) {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto p-6">
      <Card>
        <CardContent className="p-12 text-center space-y-4">
          <div className="space-y-2">
            <h1 className="text-2xl font-bold">{title}</h1>
            <p className="text-muted-foreground">{description}</p>
          </div>
          <Button variant="outline" onClick={() => navigate(ctaTo)}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            {ctaLabel}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export function UserLookupPage() {
  return (
    <UserManagementPlaceholderPage
      title="User Lookup"
      description="Search by name, email, or username from the Users list."
    />
  );
}

export function UserDataExportPage() {
  return (
    <UserManagementPlaceholderPage
      title="Data Export"
      description="Export user data from the Users list using the Export action."
    />
  );
}

export function UserRolesPermissionsPage() {
  return (
    <UserManagementPlaceholderPage
      title="Roles & Permissions"
      description="Open a user profile to manage assigned roles and permissions."
    />
  );
}

export function UserActivityTimelinePage() {
  return (
    <UserManagementPlaceholderPage
      title="Activity Timeline"
      description="View activity for a user from the Activity tab in their profile."
    />
  );
}

export function UserWalletManagementPage() {
  return (
    <UserManagementPlaceholderPage
      title="Wallet Management"
      description="Manage wallets from the Gamification section or select a user to drill in."
      ctaLabel="Open Wallet Management"
      ctaTo="/gamification/wallets"
    />
  );
}

export function UserBulkOperationsPage() {
  return (
    <UserManagementPlaceholderPage
      title="Bulk Operations"
      description="Use bulk actions from the Users list to update multiple users at once."
    />
  );
}
